import { useEffect } from 'react'
import { useAppDispatch } from '../../app/hooks'
import { resetButtons, setBackButtonVisible, setHomeButtonVisible } from '../menu/menuSlice'
import { Page } from '../../Page'
import { useAuth0 } from '@auth0/auth0-react'
import styles from './dataDelete.module.css'

export function AccountDetails() {
    const dispatch = useAppDispatch()
    const { user, isAuthenticated } = useAuth0()

    useEffect(() => {
        dispatch(resetButtons())
        dispatch(setBackButtonVisible(true))
        dispatch(setHomeButtonVisible(true))
    })
    return (
    <Page>
        <div className={styles.content}>
        <h1> PartyPlanner</h1>
         <h2>Account details</h2>
            <div className={styles.accountEmail}>
                <h3>Your account email</h3>
              <h4>  {isAuthenticated ? user?.email ?? '' : null} </h4>
              <p>You cannot change email for this account as the email acts as identity.</p>
              <p> If for whatever reason email needs to be changed, you must create a new account.</p>
               <p>  Bear in mind all data cannot be transferred across accounts.
                 For any further enquiries contact customer-services@abs.uk.com </p>
            </div>
            <div className={styles.accountEmail}>
                <h3>Your account password</h3>
                <p>To change password, log out and select the forgot password option.</p>
            </div>
            </div>
            </Page>
    )

}